import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const RcngawkModal = ({ isOpen = false, onClose }) => {
  const { t } = useTranslation();
  const offersList = t('rcngawk_modal.offers_list', {
    returnObjects: true,
    defaultValue: []
  });

  const offersItems = offersList.map((activity) => (
    <li key={`${activity}`}>{activity}</li>
  ));

  const exclusionsList = t('rcngawk_modal.exclusions_list', {
    returnObjects: true,
    defaultValue: []
  });

  const exclusionsItems = exclusionsList.map((activity) => (
    <li key={`${activity}`}>{activity}</li>
  ));

  return (
    <Modal
      title={
        <div>
          <div>{t('rcngawk_modal.title')}</div>
          <div
            style={{
              fontSize: '14px',
              fontWeight: 'normal',
              color: '#888',
              marginTop: '4px'
            }}
          >
            {t('rcngawk_modal.subtitle')}
          </div>
        </div>
      }
      onCancel={onClose}
      footer={[
        <div
          key="buttons"
          style={{ display: 'flex', justifyContent: 'space-between' }}
        >
          <Button key="cancel" onClick={onClose}>
            {t('buttons.back')}
          </Button>
          <Link to="/quotes/rcngawk/create" key="confirm">
            <Button type="primary">{t('rcngawk_modal.confirm')}</Button>
          </Link>
        </div>
      ]}
      centered
      open={isOpen}
      width="900px"
    >
      <div>
        <h3>{t('rcngawk_modal.title_offers')}</h3>
        <ul>{offersItems}</ul>
        <div>
          <h3>{t('rcngawk_modal.title_exclusions')}</h3>
          <ul>{exclusionsItems}</ul>
        </div>
      </div>
    </Modal>
  );
};

RcngawkModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default RcngawkModal;
